import React from "react";
import { useState, useEffect } from "react";
import Navbar from "./NavBar/Navbar";
import "./header.css";
import Select from "react-select";
import { Link } from "react-router-dom";

function Header(props) {
  const { eventImage, setEventImage, classUpdate, setClassUpdate } = props;

  const listenScrollEvent = () => {
    window.scrollY > 60
      ? (document.getElementById("nav").className = "nav_container_fixed")
      : // setnavColor("#252734")
        (document.getElementById("nav").className = "nav_container");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  const [selectedOption, setSelectedOption] = useState(null);

  const options = [
    { value: "Wedding", label: "Wedding" },
    { value: "Destination Wedding", label: "Destination Wedding" },
    { value: "Birthday", label: "Birthday" },
    { value: "Haldi Mehndi Sangeet", label: "Haldi, Mehndi and Sangeet" },
    { value: "Corporate Event", label: "Corporate Events" },
    { value: "Surprise Parties", label: "Surprise Parties" },
    {
      value: "Coctail Party",
      label: "Coctail Party/ Bachelor Party",
    },
    { value: "Anniversary", label: "Anniversary" },
  ];

  return (
    <div className="header_container">
      <Navbar />

      <div className="header_content">
        <p className="header_text">PLAN YOUR EVENT</p>

        <p className="header_tagline">
          Find a one-stop solution to all of your Dream Event come true
        </p>

        <div className="header_input">
          <Select
            id="eventcat"
            required
            className="header_dropdown"
            name="eventCategory"
            placeholder="Select a Event"
            value={selectedOption}
            defaultValue={selectedOption}
            onChange={setSelectedOption}
            options={options}
          />
          {/* <div class="select" tabindex="1">
            <input
              class="selectopt"
              name="test"
              type="radio"
              id="opt1"
              checked
            />
            <label for="opt1" class="option" id="Birthday Party">
              Birthday Party
            </label>
            <input class="selectopt" name="test" type="radio" id="opt2" />
            <label
              for="opt2"
              class="option"
              id="Haldi Ceremony"
              onClick={(e) => setInput(e.target.id)}
            >
              Haldi Ceremony
            </label>
            
            <input class="selectopt" name="test" type="radio" id="opt4" />
            <label
              for="opt4"
              class="option"
              id="Wedding Ceremony"
              onClick={(e) => setInput(e.target.id)}
            >
              Wedding Ceremony
            </label>
          </div> */}
          {/* <Link to="#gallery"> */}
          <button
            onClick={() => {
              window.location.replace("/#gallery");
              setClassUpdate(selectedOption ? selectedOption.value : "");
              setEventImage(selectedOption ? selectedOption.value : "");
            }}
            className="btn_get_started"
          >
            GET STARTED
          </button>
          {/* </Link> */}
        </div>
      </div>
    </div>
  );
}

export default Header;
